import { yen } from "../lib/api";
import { useStore } from "../lib/store";
import { useI18n } from "../lib/i18n";
import { Share2 } from "lucide-react";

export const ShareProductButton = ({ product, testid }) => {
  const { t } = useI18n();
  const { storeName, whatsappNumber } = useStore();

  const share = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const page = product.kind === "menu" ? "/resto" : "/toko";
    void page;
    const url = `${window.location.origin}/produk/${product.id}`;
    const text =
      `*${product.name}* — ${yen(product.price)}${product.weight ? ` / ${product.weight}` : ""}\n` +
      `${storeName}\n` +
      (product.image_url ? `${product.image_url}\n` : "") +
      `Pesan di sini: ${url}`;
    const digits = (whatsappNumber || "").replace(/[^0-9]/g, "");
    const wa = digits
      ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}`
      : `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(wa, "_blank", "noopener");
  };

  return (
    <button
      data-testid={testid}
      onClick={share}
      aria-label={t("share_wa")}
      title={t("share_wa")}
      className="absolute top-2 right-2 grid place-items-center h-8 w-8 rounded-full bg-white/90 text-[#128C7E] shadow-sm hover:bg-white hover:scale-110 transition-all duration-200"
    >
      <Share2 size={15} />
    </button>
  );
};
